'use strict';

exports.__esModule = true;
var _isUndefined = require('lodash/isUndefined');
var _isUndefined2 = _interopRequireDefault(_isUndefined);
var _isFunction = require('lodash/isFunction');
var _isFunction2 = _interopRequireDefault(_isFunction);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
exports["default"] = function (message) {
  if (!(0, _isUndefined2["default"])(console) && (0, _isFunction2["default"])(console.error)) {
    // eslint-disable-line no-console
    console.error(message); // eslint-disable-line no-console
  }
};